var _a;
// this file is autogenerated, dont change manually
// see cli/src/designkit/handle-variables.ts to change
import config from 'hops-config';
const getGlobalThis = () => {
    if (typeof globalThis !== 'undefined')
        return globalThis;
    if (typeof self !== 'undefined')
        return self;
    if (typeof window !== 'undefined')
        return window;
    if (typeof global !== 'undefined')
        return global;
    if (typeof this !== 'undefined')
        return this;
    throw new Error('Unable to locate global this');
};
// eslint-disable-next-line no-var
var globalThis = getGlobalThis();
const isThemable = config.themable;
// @ts-ignore
const isIE = !isThemable ||
    (!!globalThis.MSInputMethodContext && !!((_a = globalThis.document) === null || _a === void 0 ? void 0 : _a.documentMode));
export const spaceXXS = '2px';
export const spaceXS = '4px';
export const spaceS = '8px';
export const spaceM = '12px';
export const spaceL = '16px';
export const spaceXL = '24px';
export const spaceXXL = '32px';
export const space3XL = '48px';
export const space4XL = '68px';
export const space5XL = '92px';
export const space6XL = '122px';
export const scale000 = '0';
export const scale005 = '1px';
export const scale010 = '2px';
export const scale020 = '4px';
export const scale030 = '6px';
export const scale040 = '8px';
export const scale050 = '10px';
export const scale060 = '12px';
export const scale070 = '14px';
export const scale080 = '16px';
export const scale090 = '18px';
export const scale100 = '20px';
export const scale110 = '24px';
export const scale120 = '28px';
export const scale130 = '32px';
export const scale140 = '36px';
export const scale150 = '42px';
export const scale160 = '48px';
export const scale170 = '54px';
export const scale180 = '60px';
export const scale190 = '68px';
export const scale200 = '76px';
export const scale210 = '84px';
export const scale220 = '92px';
export const scale230 = '102px';
export const scale240 = '112px';
export const scale250 = '122px';
export const scale260 = '132px';
export const scale270 = '144px';
export const scale280 = '156px';
export const scale290 = '168px';
export const scale300 = '180px';
export const scale310 = '194px';
export const scale320 = '208px';
export const scale330 = '222px';
export const scale340 = '236px';
export const scale350 = '252px';
export const scale360 = '268px';
export const scale370 = '284px';
export const scale380 = '300px';
export const scale390 = '318px';
export const scale400 = '336px';
export const scale410 = '354px';
export const scale420 = '372px';
export const scale430 = '392px';
export const scale440 = '412px';
export const scale450 = '432px';
export const motionTimeXXS = '70ms';
export const motionTimeNumberXXS = '70';
export const motionTimeXS = '110ms';
export const motionTimeNumberXS = '110';
export const motionTimeS = '150ms';
export const motionTimeNumberS = '150';
export const motionTimeM = '240ms';
export const motionTimeNumberM = '240';
export const motionTimeL = '400ms';
export const motionTimeNumberL = '400';
export const motionTimeXL = '700ms';
export const motionTimeNumberXL = '700';
export const motionTimeXXL = '1000ms';
export const motionTimeNumberXXL = '1000';
export const motionEasingEnter = 'cubic-bezier(0, 0, 0.2, 1)';
export const motionEasingLeave = 'cubic-bezier(0.4, 0, 1, 1)';
export const motionEasingStandard = 'cubic-bezier(0.4, 0, 0.2, 1)';
export const dropShadowM = '0 4px 16px 3px rgba(33, 42, 54, 0.13)';
export const dropShadowS = '0 2px 5px 1px rgba(33, 42, 54, 0.15)';
export const cornerRadiusS = '2px';
export const cornerRadiusM = '4px';
export const cornerRadiusL = '8px';
export const cornerRadiusXL = '16px';
export const xdlColorBackground = isIE
    ? '#FFFFFF'
    : 'var(--xdlColorBackground)';
export const xdlColorBackgroundSecondary = isIE
    ? '#F9FAFA'
    : 'var(--xdlColorBackgroundSecondary)';
export const xdlColorBackgroundTertiary = isIE
    ? '#F4F4F5'
    : 'var(--xdlColorBackgroundTertiary)';
export const xdlColorBeta = isIE ? '#F4164D' : 'var(--xdlColorBeta)';
export const xdlColorBorder = isIE ? '#BCC9D1' : 'var(--xdlColorBorder)';
export const xdlColorBorderSoft = isIE
    ? '#DBE2E6'
    : 'var(--xdlColorBorderSoft)';
export const xdlColorBorderStrong = isIE
    ? '#1D2124'
    : 'var(--xdlColorBorderStrong)';
export const xdlColorCaution = isIE ? '#FE7A6C' : 'var(--xdlColorCaution)';
export const xdlColorControlBorder = isIE
    ? '#BCC9D1'
    : 'var(--xdlColorControlBorder)';
export const xdlColorControlBorderSecondary = isIE
    ? '#1D2124'
    : 'var(--xdlColorControlBorderSecondary)';
export const xdlColorControlBorderTertiary = isIE
    ? '#FFFFFF'
    : 'var(--xdlColorControlBorderTertiary)';
export const xdlColorControlFill = isIE
    ? '#FFFFFF'
    : 'var(--xdlColorControlFill)';
export const xdlColorControlFillQuaternary = isIE
    ? '#1D2124'
    : 'var(--xdlColorControlFillQuaternary)';
export const xdlColorControlFillSecondary = isIE
    ? '#F4F4F5'
    : 'var(--xdlColorControlFillSecondary)';
export const xdlColorControlFillTertiary = isIE
    ? '#DBE2E6'
    : 'var(--xdlColorControlFillTertiary)';
export const xdlColorDimming = isIE ? '#161C24' : 'var(--xdlColorDimming)';
export const xdlColorDisabled = isIE ? '#DBE2E6' : 'var(--xdlColorDisabled)';
export const xdlColorDisabledSoft = isIE
    ? '#E9EEF0'
    : 'var(--xdlColorDisabledSoft)';
export const xdlColorDisabledStrong = isIE
    ? '#BCC9D1'
    : 'var(--xdlColorDisabledStrong)';
export const xdlColorError = isIE ? '#F4164D' : 'var(--xdlColorError)';
export const xdlColorErrorSoft = isIE ? '#F8DDDF' : 'var(--xdlColorErrorSoft)';
export const xdlColorFocussed = isIE ? '#0698A0' : 'var(--xdlColorFocussed)';
export const xdlColorGo = isIE ? '#00AD85' : 'var(--xdlColorGo)';
export const xdlColorHighlighted = isIE
    ? '#A0D416'
    : 'var(--xdlColorHighlighted)';
export const xdlColorHover = isIE ? '#F4F4F5' : 'var(--xdlColorHover)';
export const xdlColorHoverQuaternary = isIE
    ? '#414D5D'
    : 'var(--xdlColorHoverQuaternary)';
export const xdlColorHoverSecondary = isIE
    ? '#E9EEF0'
    : 'var(--xdlColorHoverSecondary)';
export const xdlColorHoverTertiary = isIE
    ? '#BCC9D1'
    : 'var(--xdlColorHoverTertiary)';
export const xdlColorInfo = isIE ? '#97B7F7' : 'var(--xdlColorInfo)';
export const xdlColorInfoSoft = isIE ? '#E3EDFE' : 'var(--xdlColorInfoSoft)';
export const xdlColorLink = isIE ? '#0698A0' : 'var(--xdlColorLink)';
export const xdlColorLinkHover = isIE ? '#007B80' : 'var(--xdlColorLinkHover)';
export const xdlColorLinkVisited = isIE
    ? '#7C8A9C'
    : 'var(--xdlColorLinkVisited)';
export const xdlColorNew = isIE ? '#F4164D' : 'var(--xdlColorNew)';
export const xdlColorNotification = isIE
    ? '#F4164D'
    : 'var(--xdlColorNotification)';
export const xdlColorPremium = isIE ? '#0698A0' : 'var(--xdlColorPremium)';
export const xdlColorPremiumSecondary = isIE
    ? '#007B80'
    : 'var(--xdlColorPremiumSecondary)';
export const xdlColorPremiumTertiary = isIE
    ? '#E1F3F3'
    : 'var(--xdlColorPremiumTertiary)';
export const xdlColorPricing = isIE ? '#9C195B' : 'var(--xdlColorPricing)';
export const xdlColorPrimaryButtonHover = isIE
    ? '#A0D416'
    : 'var(--xdlColorPrimaryButtonHover)';
export const xdlColorProBusiness = isIE
    ? '#73418D'
    : 'var(--xdlColorProBusiness)';
export const xdlColorProBusinessQuaternary = isIE
    ? '#E1CFEE'
    : 'var(--xdlColorProBusinessQuaternary)';
export const xdlColorProBusinessSecondary = isIE
    ? '#663082'
    : 'var(--xdlColorProBusinessSecondary)';
export const xdlColorProBusinessTertiary = isIE
    ? '#F2F5F9'
    : 'var(--xdlColorProBusinessTertiary)';
export const xdlColorProJobs = isIE ? '#9C195B' : 'var(--xdlColorProJobs)';
export const xdlColorProJobsQuaternary = isIE
    ? '#E5BCD0'
    : 'var(--xdlColorProJobsQuaternary)';
export const xdlColorProJobsSecondary = isIE
    ? '#940F62'
    : 'var(--xdlColorProJobsSecondary)';
export const xdlColorProJobsTertiary = isIE
    ? '#F2F5F9'
    : 'var(--xdlColorProJobsTertiary)';
export const xdlColorSelected = isIE ? '#1D2124' : 'var(--xdlColorSelected)';
export const xdlColorSelectedSecondary = isIE
    ? '#0698A0'
    : 'var(--xdlColorSelectedSecondary)';
export const xdlColorSelectedTertiary = isIE
    ? '#84D4D5'
    : 'var(--xdlColorSelectedTertiary)';
export const xdlColorSkeletonPrimary = isIE
    ? '#E9EEF0'
    : 'var(--xdlColorSkeletonPrimary)';
export const xdlColorSkeletonPrimaryAnimation = isIE
    ? '#DBE2E6'
    : 'var(--xdlColorSkeletonPrimaryAnimation)';
export const xdlColorSkeletonSecondary = isIE
    ? '#BCC9D1'
    : 'var(--xdlColorSkeletonSecondary)';
export const xdlColorSkeletonSecondaryAnimation = isIE
    ? '#A4B2BA'
    : 'var(--xdlColorSkeletonSecondaryAnimation)';
export const xdlColorStop = isIE ? '#F4164D' : 'var(--xdlColorStop)';
export const xdlColorSuccess = isIE ? '#00AD85' : 'var(--xdlColorSuccess)';
export const xdlColorSuccessSoft = isIE
    ? '#C7F8EB'
    : 'var(--xdlColorSuccessSoft)';
export const xdlColorText = isIE ? '#1D2124' : 'var(--xdlColorText)';
export const xdlColorTextInvert = isIE
    ? '#FFFFFF'
    : 'var(--xdlColorTextInvert)';
export const xdlColorTextOnDark = isIE
    ? '#FFFFFF'
    : 'var(--xdlColorTextOnDark)';
export const xdlColorTextOnLight = isIE
    ? '#1D2124'
    : 'var(--xdlColorTextOnLight)';
export const xdlColorTextSecondary = isIE
    ? '#5E737D'
    : 'var(--xdlColorTextSecondary)';
export const xdlColorTextSecondaryOnDark = isIE
    ? '#BCC9D1'
    : 'var(--xdlColorTextSecondaryOnDark)';
export const xdlColorTextSecondaryOnLight = isIE
    ? '#5E737D'
    : 'var(--xdlColorTextSecondaryOnLight)';
export const xdlColorTextTertiary = isIE
    ? '#8A9DA6'
    : 'var(--xdlColorTextTertiary)';
export const xdlColorTextTertiaryOnDark = isIE
    ? '#5E737D'
    : 'var(--xdlColorTextTertiaryOnDark)';
export const xdlColorTextTertiaryOnLight = isIE
    ? '#8A9DA6'
    : 'var(--xdlColorTextTertiaryOnLight)';
export const xdlColorUnseen = isIE ? '#F4164D' : 'var(--xdlColorUnseen)';
export const xdlColorUserRoles = isIE ? '#7C8A9C' : 'var(--xdlColorUserRoles)';
export const xdlColorXING = isIE ? '#C6F16D' : 'var(--xdlColorXING)';
export const xdlPaletteBerry01 = isIE ? '#FDF1F7' : 'var(--xdlPaletteBerry01)';
export const xdlPaletteBerry02 = isIE ? '#EFCFDF' : 'var(--xdlPaletteBerry02)';
export const xdlPaletteBerry03 = isIE ? '#E5BCD0' : 'var(--xdlPaletteBerry03)';
export const xdlPaletteBerry04 = isIE ? '#DC97BA' : 'var(--xdlPaletteBerry04)';
export const xdlPaletteBerry05 = isIE ? '#D4699E' : 'var(--xdlPaletteBerry05)';
export const xdlPaletteBerry06 = isIE ? '#CA4481' : 'var(--xdlPaletteBerry06)';
export const xdlPaletteBerry07 = isIE ? '#B23975' : 'var(--xdlPaletteBerry07)';
export const xdlPaletteBerry08 = isIE ? '#9C195B' : 'var(--xdlPaletteBerry08)';
export const xdlPaletteBerry09 = isIE ? '#940F62' : 'var(--xdlPaletteBerry09)';
export const xdlPaletteBerry10 = isIE ? '#83095D' : 'var(--xdlPaletteBerry10)';
export const xdlPaletteBerry11 = isIE ? '#6D0253' : 'var(--xdlPaletteBerry11)';
export const xdlPaletteBlue01 = isIE ? '#F1F6FE' : 'var(--xdlPaletteBlue01)';
export const xdlPaletteBlue02 = isIE ? '#E3EDFE' : 'var(--xdlPaletteBlue02)';
export const xdlPaletteBlue03 = isIE ? '#C9DCFB' : 'var(--xdlPaletteBlue03)';
export const xdlPaletteBlue04 = isIE ? '#97B7F7' : 'var(--xdlPaletteBlue04)';
export const xdlPaletteBlue05 = isIE ? '#5790EB' : 'var(--xdlPaletteBlue05)';
export const xdlPaletteBlue06 = isIE ? '#3C80EB' : 'var(--xdlPaletteBlue06)';
export const xdlPaletteBlue07 = isIE ? '#2866E6' : 'var(--xdlPaletteBlue07)';
export const xdlPaletteBlue08 = isIE ? '#1C4FB8' : 'var(--xdlPaletteBlue08)';
export const xdlPaletteBlue09 = isIE ? '#0D3994' : 'var(--xdlPaletteBlue09)';
export const xdlPaletteBlue10 = isIE ? '#022B7F' : 'var(--xdlPaletteBlue10)';
export const xdlPaletteBlue11 = isIE ? '#002166' : 'var(--xdlPaletteBlue11)';
export const xdlPaletteGrayCool01 = isIE
    ? '#F2F5F9'
    : 'var(--xdlPaletteGrayCool01)';
export const xdlPaletteGrayCool02 = isIE
    ? '#E9EEF5'
    : 'var(--xdlPaletteGrayCool02)';
export const xdlPaletteGrayCool03 = isIE
    ? '#E1E8F5'
    : 'var(--xdlPaletteGrayCool03)';
export const xdlPaletteGrayCool04 = isIE
    ? '#CAD3E2'
    : 'var(--xdlPaletteGrayCool04)';
export const xdlPaletteGrayCool05 = isIE
    ? '#ACB8CA'
    : 'var(--xdlPaletteGrayCool05)';
export const xdlPaletteGrayCool06 = isIE
    ? '#7C8A9C'
    : 'var(--xdlPaletteGrayCool06)';
export const xdlPaletteGrayCool07 = isIE
    ? '#616D7D'
    : 'var(--xdlPaletteGrayCool07)';
export const xdlPaletteGrayCool08 = isIE
    ? '#414D5D'
    : 'var(--xdlPaletteGrayCool08)';
export const xdlPaletteGrayCool09 = isIE
    ? '#293545'
    : 'var(--xdlPaletteGrayCool09)';
export const xdlPaletteGrayCool10 = isIE
    ? '#212A36'
    : 'var(--xdlPaletteGrayCool10)';
export const xdlPaletteGrayCool11 = isIE
    ? '#161C24'
    : 'var(--xdlPaletteGrayCool11)';
export const xdlPaletteGrayPlain01 = isIE
    ? '#F9FAFA'
    : 'var(--xdlPaletteGrayPlain01)';
export const xdlPaletteGrayPlain02 = isIE
    ? '#F4F4F5'
    : 'var(--xdlPaletteGrayPlain02)';
export const xdlPaletteGrayPlain03 = isIE
    ? '#E9EEF0'
    : 'var(--xdlPaletteGrayPlain03)';
export const xdlPaletteGrayPlain04 = isIE
    ? '#DBE2E6'
    : 'var(--xdlPaletteGrayPlain04)';
export const xdlPaletteGrayPlain05 = isIE
    ? '#BCC9D1'
    : 'var(--xdlPaletteGrayPlain05)';
export const xdlPaletteGrayPlain06 = isIE
    ? '#A4B2BA'
    : 'var(--xdlPaletteGrayPlain06)';
export const xdlPaletteGrayPlain07 = isIE
    ? '#8A9DA6'
    : 'var(--xdlPaletteGrayPlain07)';
export const xdlPaletteGrayPlain08 = isIE
    ? '#5E737D'
    : 'var(--xdlPaletteGrayPlain08)';
export const xdlPaletteGrayPlain09 = isIE
    ? '#435057'
    : 'var(--xdlPaletteGrayPlain09)';
export const xdlPaletteGrayPlain10 = isIE
    ? '#343C40'
    : 'var(--xdlPaletteGrayPlain10)';
export const xdlPaletteGrayPlain11 = isIE
    ? '#1D2124'
    : 'var(--xdlPaletteGrayPlain11)';
export const xdlPaletteLime01 = isIE ? '#F9FFEF' : 'var(--xdlPaletteLime01)';
export const xdlPaletteLime02 = isIE ? '#F3FAE6' : 'var(--xdlPaletteLime02)';
export const xdlPaletteLime03 = isIE ? '#E8F5CE' : 'var(--xdlPaletteLime03)';
export const xdlPaletteLime04 = isIE ? '#DAF5A4' : 'var(--xdlPaletteLime04)';
export const xdlPaletteLime05 = isIE ? '#D3F58E' : 'var(--xdlPaletteLime05)';
export const xdlPaletteLime06 = isIE ? '#CBF576' : 'var(--xdlPaletteLime06)';
export const xdlPaletteLime07 = isIE ? '#C6F16D' : 'var(--xdlPaletteLime07)';
export const xdlPaletteLime08 = isIE ? '#B7E854' : 'var(--xdlPaletteLime08)';
export const xdlPaletteLime09 = isIE ? '#B7DF4B' : 'var(--xdlPaletteLime09)';
export const xdlPaletteLime10 = isIE ? '#AEDB33' : 'var(--xdlPaletteLime10)';
export const xdlPaletteLime11 = isIE ? '#A0D416' : 'var(--xdlPaletteLime11)';
export const xdlPaletteMint01 = isIE ? '#E0FEF6' : 'var(--xdlPaletteMint01)';
export const xdlPaletteMint02 = isIE ? '#C7F8EB' : 'var(--xdlPaletteMint02)';
export const xdlPaletteMint03 = isIE ? '#A3F0DB' : 'var(--xdlPaletteMint03)';
export const xdlPaletteMint04 = isIE ? '#73EACA' : 'var(--xdlPaletteMint04)';
export const xdlPaletteMint05 = isIE ? '#30E5B2' : 'var(--xdlPaletteMint05)';
export const xdlPaletteMint06 = isIE ? '#27DBA8' : 'var(--xdlPaletteMint06)';
export const xdlPaletteMint07 = isIE ? '#00D296' : 'var(--xdlPaletteMint07)';
export const xdlPaletteMint08 = isIE ? '#00C48C' : 'var(--xdlPaletteMint08)';
export const xdlPaletteMint09 = isIE ? '#00AD85' : 'var(--xdlPaletteMint09)';
export const xdlPaletteMint10 = isIE ? '#009C77' : 'var(--xdlPaletteMint10)';
export const xdlPaletteMint11 = isIE ? '#007C5F' : 'var(--xdlPaletteMint11)';
export const xdlPaletteOrange01 = isIE
    ? '#FEE4DC'
    : 'var(--xdlPaletteOrange01)';
export const xdlPaletteOrange02 = isIE
    ? '#FEDAD2'
    : 'var(--xdlPaletteOrange02)';
export const xdlPaletteOrange03 = isIE
    ? '#FECFC8'
    : 'var(--xdlPaletteOrange03)';
export const xdlPaletteOrange04 = isIE
    ? '#FEC0B9'
    : 'var(--xdlPaletteOrange04)';
export const xdlPaletteOrange05 = isIE
    ? '#FEADA9'
    : 'var(--xdlPaletteOrange05)';
export const xdlPaletteOrange06 = isIE
    ? '#FE9A95'
    : 'var(--xdlPaletteOrange06)';
export const xdlPaletteOrange07 = isIE
    ? '#FF847E'
    : 'var(--xdlPaletteOrange07)';
export const xdlPaletteOrange08 = isIE
    ? '#FE7A6C'
    : 'var(--xdlPaletteOrange08)';
export const xdlPaletteOrange09 = isIE
    ? '#FE7C62'
    : 'var(--xdlPaletteOrange09)';
export const xdlPaletteOrange10 = isIE
    ? '#FE6F53'
    : 'var(--xdlPaletteOrange10)';
export const xdlPaletteOrange11 = isIE
    ? '#FE6648'
    : 'var(--xdlPaletteOrange11)';
export const xdlPalettePetrol01 = isIE
    ? '#EEF6F6'
    : 'var(--xdlPalettePetrol01)';
export const xdlPalettePetrol02 = isIE
    ? '#E1F3F3'
    : 'var(--xdlPalettePetrol02)';
export const xdlPalettePetrol03 = isIE
    ? '#BBE7E8'
    : 'var(--xdlPalettePetrol03)';
export const xdlPalettePetrol04 = isIE
    ? '#84D4D5'
    : 'var(--xdlPalettePetrol04)';
export const xdlPalettePetrol05 = isIE
    ? '#46B7BB'
    : 'var(--xdlPalettePetrol05)';
export const xdlPalettePetrol06 = isIE
    ? '#06A7AC'
    : 'var(--xdlPalettePetrol06)';
export const xdlPalettePetrol07 = isIE
    ? '#0698A0'
    : 'var(--xdlPalettePetrol07)';
export const xdlPalettePetrol08 = isIE
    ? '#05888F'
    : 'var(--xdlPalettePetrol08)';
export const xdlPalettePetrol09 = isIE
    ? '#007B80'
    : 'var(--xdlPalettePetrol09)';
export const xdlPalettePetrol10 = isIE
    ? '#006567'
    : 'var(--xdlPalettePetrol10)';
export const xdlPalettePetrol11 = isIE
    ? '#005357'
    : 'var(--xdlPalettePetrol11)';
export const xdlPalettePurple01 = isIE
    ? '#F8EFFF'
    : 'var(--xdlPalettePurple01)';
export const xdlPalettePurple02 = isIE
    ? '#EADDF3'
    : 'var(--xdlPalettePurple02)';
export const xdlPalettePurple03 = isIE
    ? '#E1CFEE'
    : 'var(--xdlPalettePurple03)';
export const xdlPalettePurple04 = isIE
    ? '#C5ADD1'
    : 'var(--xdlPalettePurple04)';
export const xdlPalettePurple05 = isIE
    ? '#AE8DBF'
    : 'var(--xdlPalettePurple05)';
export const xdlPalettePurple06 = isIE
    ? '#9569AB'
    : 'var(--xdlPalettePurple06)';
export const xdlPalettePurple07 = isIE
    ? '#85599B'
    : 'var(--xdlPalettePurple07)';
export const xdlPalettePurple08 = isIE
    ? '#73418D'
    : 'var(--xdlPalettePurple08)';
export const xdlPalettePurple09 = isIE
    ? '#663082'
    : 'var(--xdlPalettePurple09)';
export const xdlPalettePurple10 = isIE
    ? '#511E6C'
    : 'var(--xdlPalettePurple10)';
export const xdlPalettePurple11 = isIE
    ? '#40075E'
    : 'var(--xdlPalettePurple11)';
export const xdlPaletteRed01 = isIE ? '#F8E8E9' : 'var(--xdlPaletteRed01)';
export const xdlPaletteRed02 = isIE ? '#F8DDDF' : 'var(--xdlPaletteRed02)';
export const xdlPaletteRed03 = isIE ? '#FEBDC3' : 'var(--xdlPaletteRed03)';
export const xdlPaletteRed04 = isIE ? '#FF8D9A' : 'var(--xdlPaletteRed04)';
export const xdlPaletteRed05 = isIE ? '#F25C6E' : 'var(--xdlPaletteRed05)';
export const xdlPaletteRed06 = isIE ? '#F34B65' : 'var(--xdlPaletteRed06)';
export const xdlPaletteRed07 = isIE ? '#FC2558' : 'var(--xdlPaletteRed07)';
export const xdlPaletteRed08 = isIE ? '#F4164D' : 'var(--xdlPaletteRed08)';
export const xdlPaletteRed09 = isIE ? '#DD0543' : 'var(--xdlPaletteRed09)';
export const xdlPaletteRed10 = isIE ? '#CF0231' : 'var(--xdlPaletteRed10)';
export const xdlPaletteRed11 = isIE ? '#BB0034' : 'var(--xdlPaletteRed11)';
export const xdlPaletteWhite = isIE ? '#FFFFFF' : 'var(--xdlPaletteWhite)';
export const xdlPaletteYellow01 = isIE
    ? '#FFF4D1'
    : 'var(--xdlPaletteYellow01)';
export const xdlPaletteYellow02 = isIE
    ? '#FFEFBE'
    : 'var(--xdlPaletteYellow02)';
export const xdlPaletteYellow03 = isIE
    ? '#FDEBB2'
    : 'var(--xdlPaletteYellow03)';
export const xdlPaletteYellow04 = isIE
    ? '#FCE59D'
    : 'var(--xdlPaletteYellow04)';
export const xdlPaletteYellow05 = isIE
    ? '#FEE284'
    : 'var(--xdlPaletteYellow05)';
export const xdlPaletteYellow06 = isIE
    ? '#FFDE70'
    : 'var(--xdlPaletteYellow06)';
export const xdlPaletteYellow07 = isIE
    ? '#FFDA5F'
    : 'var(--xdlPaletteYellow07)';
export const xdlPaletteYellow08 = isIE
    ? '#FFD547'
    : 'var(--xdlPaletteYellow08)';
export const xdlPaletteYellow09 = isIE
    ? '#FDD039'
    : 'var(--xdlPaletteYellow09)';
export const xdlPaletteYellow10 = isIE
    ? '#FDCC25'
    : 'var(--xdlPaletteYellow10)';
export const xdlPaletteYellow11 = isIE
    ? '#FFC911'
    : 'var(--xdlPaletteYellow11)';
//# sourceMappingURL=tokens.js.map